import { Field } from '@sitecore-content-sdk/nextjs';

const facetGroupFieldsFragment = /** GQL */ `
fragment FacetGroupFields on Item {
  id
  name
  template {
    id
    name
  }
  groupName: field(name: "groupName") {
    jsonValue
  }
  groupLabel: field(name: "groupLabel") {
    jsonValue
  }
  expandedByDefault: field(name: "expandedByDefault") {
    jsonValue
  }
  showMoreThreshold: field(name: "showMoreThreshold") {
    jsonValue
  }
  sortOrder: field(name: "sortOrder") {
    jsonValue
  }
  children {
    results {
      id
      name
      template {
        id
        name
      }
      facetId: field(name: "facetId") {
        jsonValue
      }
      isPinned: field(name: "isPinned") {
        jsonValue
      }
      isPinnedDisplayName: field(name: "is pinned") {
        jsonValue
      }
      valueLabel: field(name: "valueLabel") {
        jsonValue
      }
    }
  }
}
`;

const SearchConfigurationQuery = /** GQL */ `query SearchConfigurationQuery($path: String!, $language: String!) {
  item(path: $path, language: $language) {
    id
    name
    template {
      id
      name
    }
    configurationName: field(name: "configurationName") {
      jsonValue
    }
    facetGroup: field(name: "facetGroup") {
      jsonValue
      ... on MultilistField {
        targetItems {
          ...FacetGroupFields
        }
      }
    }
    children {
      results {
        id
        name
        template {
          id
          name
        }
        fields {
          name
          value
          jsonValue
        }
      }
    }
  }
}

${facetGroupFieldsFragment}`;

export const FacetGroupQuery = /** GQL */ `query FacetGroupQuery($path: String!, $language: String!) {
  item(path: $path, language: $language) {
    id
    name
    template {
      id
      name
    }
    groupName: field(name: "groupName") {
      jsonValue
    }
    groupLabel: field(name: "groupLabel") {
      jsonValue
    }
    expandedByDefault: field(name: "expandedByDefault") {
      jsonValue
    }
    showMoreThreshold: field(name: "showMoreThreshold") {
      jsonValue
    }
    sortOrder: field(name: "sortOrder") {
      jsonValue
    }
    children(first: 100) {
      results {
        id
        name
        template {
          id
          name
        }
        facetId: field(name: "facetId") {
          jsonValue
        }
        isPinned: field(name: "isPinned") {
          jsonValue
        }
        isPinnedDisplayName: field(name: "is pinned") {
          jsonValue
        }
        valueLabel: field(name: "valueLabel") {
          jsonValue
        }
      }
    }
  }
}`;

export default SearchConfigurationQuery;

export type SearchConfigurationQueryResult = {
  item?: {
    id: string;
    name: string;
    template?: {
      id: string;
      name: string;
    };
    configurationName?: {
      jsonValue: Field<string>;
    };
    facetGroup?: {
      jsonValue?: {
        id?: string;
        name?: string;
        url?: string;
        displayName?: string;
        fields?: Record<string, unknown>;
      }[];
      targetItems?: FacetGroupQueryResult['item'][];
    };
    children?: {
      results?: {
        id: string;
        name: string;
        template?: {
          id: string;
          name: string;
        };
        fields?: {
          name: string;
          value?: string;
          jsonValue?: unknown;
        }[];
      }[];
    };
  };
};

export type FacetGroupQueryResult = {
  item?: {
    id: string;
    name: string;
    template?: {
      id: string;
      name: string;
    };
    groupName?: {
      jsonValue: Field<string>;
    };
    groupLabel?: {
      jsonValue: Field<string>;
    };
    expandedByDefault?: {
      jsonValue: Field<boolean>;
    };
    showMoreThreshold?: {
      jsonValue: Field<string>;
    };
    sortOrder?: {
      jsonValue?: {
        id?: string;
        name?: string;
      }[];
    };
    children?: {
      results?: {
        id: string;
        name: string;
        template?: {
          id: string;
          name: string;
        };
        facetId?: {
          jsonValue: Field<string>;
        };
        isPinned?: {
          jsonValue: Field<boolean>;
        };
        isPinnedDisplayName?: {
          jsonValue: Field<boolean>;
        };
        valueLabel?: {
          jsonValue: Field<string>;
        };
      }[];
    };
  };
};
